"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const statusColors = {
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
  GREY: 'grey'
};
const Status = props => {
  const {
    statusColor = 'grey',
    className,
    prefix = '',
    small,
    label,
    statusDotPosition = 'leading',
    ...other
  } = props;
  const classes = (0, _classnames.default)(`${prefix}status`, className, `${prefix}status--${statusColor}`, label && `${prefix}status--labelled ${prefix}status--${statusDotPosition}`, small && `${prefix}status--small`);
  return _react.default.createElement("span", _extends({
    className: classes
  }, other), label && _react.default.createElement("span", {
    className: `${prefix}status__label`
  }, label), _react.default.createElement(DotElement, {
    statusDotPosition: statusDotPosition,
    prefix: prefix
  }));
};
const DotElement = _ref => {
  let {
    statusDotPosition,
    prefix
  } = _ref;
  return statusDotPosition === 'inline' ? _react.default.createElement("span", {
    className: `${prefix}status__dot-wrapper`
  }, "\u200A", _react.default.createElement("span", {
    className: `${prefix}status__dot`
  })) : _react.default.createElement("span", {
    className: `${prefix}status__dot`
  });
};
var _default = Status;
exports.default = _default;